import { render, staticRenderFns } from "./imagesInfo.vue?vue&type=template&id=ef1f06e8&"
import script from "./imagesInfo.vue?vue&type=script&lang=js&"
export * from "./imagesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports